export const generateKeyPathFromLocation = (location, keyPathLength) => {
  const pathParts = location.pathname.split('/').filter(Boolean);
  return pathParts.slice(0, keyPathLength).join('.');
};

export const slugify = text => {
  if (!text) {
    return '';
  }
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};

export const SEO_CONTENT_TYPE = {
  VIDEO: 'video',
  ARTICLE: 'article'
};
const mappingSeoUrlToBoatType = {
  // group
  'duck-hunting-boats': { video: {type: ['group', 'class'], criteria: 'duck-boat'}, article: {type: 'group', criteria: 'duck-boat'}},
  'fishing-boats': { video: {type: ['group', 'class'], criteria: 'fishing-boats'}, article: {type: 'group', criteria: 'fishing-boats'}},
  'pleasure-boats': { video: {type: ['group', 'class'], criteria: 'pleasure-boats'}, article: {type: 'group', criteria: 'pleasure-boats'}},
  'weekender-boats': { video: {type: ['group', 'class'], criteria: 'weekender'}, article: {type: 'group', criteria: 'weekender'}},

  // power
  'aluminum-fishing-boats': { video: { type: 'class', criteria: 'power-aluminum' }, article: { type: 'class', criteria: 'power-aluminum' } },
  'bass-boats': { video: { type: 'class', criteria: 'power-bass' }, article: { type: 'class', criteria: 'power-bass' } },
  'bay-boats': { video: { type: 'class', criteria: 'power-bay' }, article: { type: 'class', criteria: 'power-bay' } },
  'bowrider-boats': { video: { type: 'class', criteria: 'power-bowrider' }, article: { type: 'class', criteria: 'power-bowrider' } },
  'center-console-boats': { video: { type: 'class', criteria: 'power-center' }, article: { type: 'class', criteria: 'power-center' } },
  'commercial-boats': { video: { type: 'class', criteria: 'power-commercial' }, article: { type: 'class', criteria: 'power-commercial' } },
  'cruiser-boats': { video: { type: 'class', criteria: 'power-cruiser' }, article: { type: 'class', criteria: 'power-cruiser' } },
  'cuddy-cabin-boats': { video: { type: 'class', criteria: 'power-cuddy' }, article: { type: 'class', criteria: 'power-cuddy' } },
  'deck-boats': { video: { type: 'class', criteria: 'power-deck' }, article: { type: 'class', criteria: 'power-deck' } },
  'freshwater-fishing-boats': { video: { type: 'class', criteria: 'power-fresh' }, article: { type: 'class', criteria: 'power-fresh' } },
  'high-performance-boats': { video: { type: 'class', criteria: 'power-highperf' }, article: { type: 'class', criteria: 'power-highperf' } },
  'houseboats': { video: { type: 'class', criteria: 'power-house' }, article: { type: 'class', criteria: 'power-house' } },
  'inflatable-boats': { video: { type: 'class', criteria: 'power-inflatable' }, article: { type: 'class', criteria: 'power-inflatable' } },
  'jet-boats': { video: { type: 'class', criteria: 'power-jet' }, article: { type: 'class', criteria: 'power-jet' } },
  'jon-boats': { video: { type: 'class', criteria: 'power-jon' }, article: { type: 'class', criteria: 'power-jon' } },
  'motor-yachts': { video: { type: 'class', criteria: 'power-motor' }, article: { type: 'class', criteria: 'power-motor' } },
  'pontoon-boats': { video: { type: 'class', criteria: 'power-pontoon' }, article: { type: 'class', criteria: 'power-pontoon' } },
  'rigid-inflatable-boats-ribs': { video: { type: 'class', criteria: 'power-rib' }, article: { type: 'class', criteria: 'power-rib' } },
  'saltwater-fishing-boats': { video: { type: 'class', criteria: 'power-saltfish' }, article: { type: 'class', criteria: 'power-saltfish' } },
  'ski-wakeboard-boats': { video: { type: 'class', criteria: 'power-skiwake' }, article: { type: 'class', criteria: 'power-skiwake' } },

  // sail
  'catamaran-boats': { video: { type: 'class', criteria: 'sail-catamaran' }, article: { type: 'class', criteria: 'sail-catamaran' } },
  'cruiser-sailboats': { video: { type: 'class', criteria: 'sail-cruiser' }, article: { type: 'class', criteria: 'sail-cruiser' } },
  'daysailer-boats': { video: { type: 'class', criteria: 'sail-day' }, article: { type: 'class', criteria: 'sail-day' } },
  'motorsailer-boats': { video: { type: 'class', criteria: 'sail-motor' }, article: { type: 'class', criteria: 'sail-motor' } },

  // type
  'pwc-jet-ski': { video: { type: 'type', criteria: 'power' } },

  // unpowered
  'canoe-kayak': { video: { type: 'class', criteria: 'unpowered-kayak' }, article: { type: 'class', criteria: 'unpowered-kayak' } },
  'dinghy-boats': { video: { type: 'class', criteria: 'unpowered-dinghy' }, article: { type: 'class', criteria: 'unpowered-dinghy' } }
};
export const generateSearchCriteriaFromKeyPath = (pageKeyPath, seoContentType) => {
  // Handle invalid inputs
  if (!pageKeyPath || typeof pageKeyPath !== 'string') {
    return undefined;
  }

  // Split the path and get the second segment (boat-types.bass-boats)
  const pathSegments = pageKeyPath.split('.');
  if (pathSegments.length < 2) {
    return undefined;
  }

  const boatType = pathSegments[1];
  if (!boatType) {
    return undefined;
  }

  const boatTypeConfig = mappingSeoUrlToBoatType[boatType];
  if (!boatTypeConfig) {
    return undefined;
  }

  return boatTypeConfig[seoContentType];
};
